import { MetaAdsWizardStepT, WizardStepT, useOrganizationWizardStepsQuery } from "../graphql/generated/graphql";

type WizardStateT = {
  googleCurrentStep: WizardStepT;
  googleWizardFinished: boolean;
  googleWizardInProgress: boolean;
  googleWizardNotStarted: boolean;
  loading: boolean;
  metaCurrentStep: MetaAdsWizardStepT;
  metaWizardFinished: boolean;
  metaWizardInProgress: boolean;
  metaWizardNotStarted: boolean;
};

const GOOGLE_WIZARD_STEPS = [
  WizardStepT.FirstT,
  WizardStepT.SuggestionGeneratorT,
  WizardStepT.ImageSelectionT,
  WizardStepT.TextSelectionT,
  WizardStepT.CheckT,
  WizardStepT.FinishT,
];

const META_WIZARD_STEPS = [
  MetaAdsWizardStepT.MetaFirstT,
  MetaAdsWizardStepT.MetaPageLinkingT,
  MetaAdsWizardStepT.MetaProductsSelectionT,
  MetaAdsWizardStepT.MetaTextSelectionT,
  MetaAdsWizardStepT.MetaBudgetT,
  MetaAdsWizardStepT.MetaFinishT,
];

export const useWizardState = (): WizardStateT => {
  const { data, loading } = useOrganizationWizardStepsQuery();

  const googleWizardStep = data?.organization?.googleAdsSetting?.wizardStep;
  const metaWizardStep = data?.organization?.metaAdsSetting?.wizardStep;

  // Google Ads Wizard State
  const googleWizardNotStarted = !googleWizardStep || googleWizardStep === WizardStepT.FirstT;
  const googleWizardFinished = googleWizardStep === WizardStepT.DashboardT;
  const googleWizardInProgress =
    !!googleWizardStep &&
    !googleWizardNotStarted &&
    !googleWizardFinished &&
    GOOGLE_WIZARD_STEPS.includes(googleWizardStep);

  // Meta Ads Wizard State
  const metaWizardNotStarted = !metaWizardStep || metaWizardStep === MetaAdsWizardStepT.MetaFirstT;
  const metaWizardFinished = metaWizardStep === MetaAdsWizardStepT.DashboardT;
  const metaWizardInProgress =
    !!metaWizardStep && !metaWizardNotStarted && !metaWizardFinished && META_WIZARD_STEPS.includes(metaWizardStep);

  return {
    googleCurrentStep: googleWizardStep || WizardStepT.FirstT,
    googleWizardFinished,
    googleWizardInProgress,
    googleWizardNotStarted,
    metaCurrentStep: metaWizardStep || MetaAdsWizardStepT.MetaFirstT,
    metaWizardFinished,
    metaWizardInProgress,
    metaWizardNotStarted,
    loading,
  };
};
